import { zodResolver } from '@hookform/resolvers/zod';
import { doctolibAccountingFileSchema } from '@omecare/utils';
import { z } from 'zod';

export const importAccountingDoctorAttendingCsvFormSchema = z.object({
  officeId: z.string({ message: 'form.errors.required' }).min(1, {
    message: 'form.errors.required',
  }),
  doctorAttending: z.object(
    {
      id: z.string(),
      label: z.string(),
      firstname: z.string(),
      lastname: z.string(),
    },
    { message: 'form.errors.required' },
  ),
  doctolibAccountingFile: doctolibAccountingFileSchema,
});

export type ImportAccountingDoctorAttendingCsvFormValues = z.infer<
  typeof importAccountingDoctorAttendingCsvFormSchema
>;

export const importAccountingDoctorAttendingCsvFormResolver = zodResolver(
  importAccountingDoctorAttendingCsvFormSchema,
);
